import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4d11c8ce&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=4d11c8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d11c8ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d11c8ce')) {
      api.createRecord('4d11c8ce', component.options)
    } else {
      api.reload('4d11c8ce', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4d11c8ce&scoped=true&", function () {
      api.rerender('4d11c8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/doubleScroll/main.vue"
export default component.exports